<template>
  <v-app>
    <v-content v-if="noDashboards && !loading">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="9" md="5" lg="3" sm="6">
            <v-card class="text-center pa-5">
              <v-icon color="primary" x-large>mdi-monitor-dashboard</v-icon>
              <div class="headline mt-2">
                {{ $t("dashboards.dashboards.noDashboardsAvailable") }}
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <DashboardsBar></DashboardsBar>
    <router-view v-if="!noDashboards" @error="handleError"></router-view>
  </v-app>
</template>

<script>
import DashboardsBar from "@/components/navigation-bar/DashboardsBar";
import api from "@/utils/api.js";
export default {
  name: "Dashboards",
  components: {
    DashboardsBar,
  },
  data: () => ({
    dashboardsList: [],
    noDashboards: true,
    loading: true,
  }),
  created() {
    this.loadDashboardList();
  },
  watch: {
    $route(to) {
      if (
        to.name === "dashboards" &&
        !to.params.id &&
        this.dashboardsList.length > 0
      ) {
        this.replaceRoute(this.dashboardsList[0].uuid);
      }
    },
  },
  methods: {
    loadDashboardList() {
      api.getDashboardList().then((resp) => {
        if (resp.data.length === 0) {
          this.noDashboards = true;
        } else {
          this.noDashboards = false;
        }
        this.dashboardsList = resp.data;
        if (resp.data.length && !this.$route.params.id) {
          this.replaceRoute(resp.data[0].uuid);
        }
        this.loading = false;
      });
    },
    replaceRoute(uuid) {
      this.$router.replace({
        name: "dashboard",
        params: { id: uuid },
      });
    },
    handleError() {
      api.getDashboardList().then((resp) => {
        if (resp.data.length.length !== 0) {
          this.replaceRoute(resp.data[0].uuid);
        }
      });
    },
  },
};
</script>

<style scoped>
iframe {
  width: 100%;
  height: 100%;
}
</style>
